import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
    Heading,
    Title,
    DesktopSubHeader,
    DesktopHeader,
} from './InventoryHeader.styled';
import BackIcon from 'src/assets/images/BaselineKeyboardArrowLeft.svg';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setProgressBarStatus } from 'src/pages/consignmentBilling/redux/actions';
import {
    accountNumberZeroTrimmer,
    getRoutePathWithParams,
    logErrorToConsole,
} from 'src/utils/util';
const InventoryHeader = (props) => {
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const history = useHistory();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        accountId,
        patientFirstName,
        patientLastName,
        physicianName,
        patient_Details,
    } = useSelector((state) => ({
        accountId: state.consignmentReducer.surgeryDetails.accountId,
        patientFirstName:
            state.consignmentReducer.surgeryDetails.patientFirstName,
        patientLastName:
            state.consignmentReducer.surgeryDetails.patientLastName,
        physicianName:
            countryISOCode === 'JP'
                ? state.consignmentReducer.surgeryDetails.physicianId
                      .physicianDisplayName
                : state.consignmentReducer.surgeryDetails.physicianId,
        patient_Details: state.loginReducer.patient_Details,
    }));
  
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const isLanguageChanged = useSelector(
        (state) => state.loginReducer.isLanguageChanged
    );
    return (
        <>
            <DesktopHeader>
                <img
                    id={`consignmentBilling-inventory-desktopHeader-backIcon-${accountId?.accountId || 'default'}`}
                    src={BackIcon}
                    alt="back"
                    onClick={() => {
                        try {
                            history.push({
                                ...getRoutePathWithParams('/consignmentBilling'),
                                // state: {
                                //     detail: {
                                //         accountId: accountId.accountId,
                                //         patientFirstName: patientFirstName,
                                //         patientLastName: patientLastName,
                                //         physicianName: physicianName,
                                //         accountName: accountId.accountName,
                                //         hrefId: hrefId,
                                //     },
                                // },
                            });
                            dispatch(setProgressBarStatus('Account'));
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    style={{
                        cursor: 'pointer',
                    }}
                />

                <DesktopSubHeader
                    marginLeft={
                        isCondensedView
                            ? '30%'
                            : isCondensedView && isLanguageChanged
                            ? '38%'
                            : 'auto'
                    }
                >
                    <Title>
                   
                        {t(
                            'consignmentBilling.inventory.addFromConsignmentInventory'
                        )}
                    </Title>
                </DesktopSubHeader>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                    }}
                >
                    <Heading className="consignment-billing-inventory-account-dt-mask" isDemi>
                        {accountId?.accountName}{' '}
                        <Heading isRegular>
                            {accountNumberZeroTrimmer(
                                accountId?.accountId || ''
                            )}
                        </Heading>
                    </Heading>

                   <Heading className="consignment-billing-inventory-account-dt-mask" isDemi style={{ marginTop: 'unset' }}>
    {physicianName
        ? `${t('common.drLabel')} ${
            typeof physicianName === 'string'
                ? physicianName
                : physicianName?.physicianDisplayName
          }`
        : ''}
    {patient_Details?.includes('Patient Name') && patientFirstName && (
        <Heading isRegular>
            {' '}
            {patientFirstName && physicianName && (
                <span style={{ paddingLeft: '4px' }}>|</span>
            )}{' '}
            <span style={{ paddingLeft: '4px' }}>
                {t('consignmentBilling.inventory.patient')}
            </span>{' '}
            {patientFirstName + ' ' + patientLastName}{' '}
        </Heading>
    )}
</Heading>
                </div>
            </DesktopHeader>
        </>
    );
};

export default InventoryHeader;
